import { Button, Modal, Form, Input, message, InputNumber, Select } from "antd";
import API from "../../../../services/api-request";

const AddMaterialHandling = (props) => {
  const [addForm] = Form.useForm();

  const onFinish = async (values) => {
    const { key, cost, type } = values;

    const dataForm = {
      key,
      cost,
      type,
    };

    await API.Post("material-handling", dataForm)
      .then(() => {
        message.success("Material Handling has been added");
        props.onGetMaterialHandling();
        addForm.resetFields();
        props.onShowAdd(false);
      })
      .catch((err) => {
        console.log(err);
        message.info(`${err?.response?.data?.error}`);
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleCancel = () => {
    props.onShowAdd(false);
    addForm.resetFields();
  };

  const typeOptions = [
    {
      value: "custom",
      label: "Custom",
    },
    {
      value: "overtime",
      label: "Overtime",
    },
    {
      value: "normal",
      label: "Normal",
    },
  ];

  return (
    <>
      <Modal
        title="Add Material Handling"
        open={props.showAdd}
        onCancel={handleCancel}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => addForm.submit()}>
            Submit
          </Button>,
        ]}
      >
        <Form
          form={addForm}
          name="Add Form"
          style={{
            margin: "0 auto",
          }}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Key"
            name="key"
            rules={[{ required: true, message: "Please input key!" }]}
          >
            <Input placeholder="Input Key" />
          </Form.Item>
          <Form.Item
            label="Cost"
            name="cost"
            rules={[{ required: true, message: "Please input cost!" }]}
          >
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              controls={false}
              placeholder="Input Cost"
            />
          </Form.Item>
          <Form.Item
            label="Type"
            name="type"
            rules={[{ required: true, message: "Please input type!" }]}
          >
            <Select options={typeOptions} placeholder="Input Type" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddMaterialHandling;
